import { EServiceType } from '../../../../../../../../redux/reducers';
import { IRecommendedPackage } from '../../../../../../../../types/reducers/recommendedPackages';
import { EInternalPackageType, IBuyPackageData } from '../../../../../../../../types/microfrontends/buyPackage';
import { pluralizeOfferLabel } from '../../../../../../../BuyPackage/BuyPackageModal/utils';
import { mapServiceType } from './mapServiceType';
import { mapWidgetSource } from './mapWidgetSource';

const dayjs = require('dayjs');

export const mapPackageToModalData = (data: IRecommendedPackage): IBuyPackageData => ({
  internalType: EInternalPackageType.SmartPackage,
  autoProlongAvailable: true,
  packageId: data.packageId,
  type: data.type,
  autoProlong: data.autoProlong,
  activationDate: dayjs(data.packageStartDate).format('DD.MM.YYYY'),
  endDate: dayjs(data.packageEndDate).format('DD.MM.YYYY'),
  regionNames: data.regionNames,
  categoriesView: data.categoriesView,
  price: data.price,
  marketingPrice: data.marketingPrice,
  discountPercent: data.discountPercent,
  durationInDays: data.durationInDays,
  services: data.services.map(service => ({
    icon: service.serviceType === EServiceType.paid ? 'offers' : 'auction-points',
    name: service.serviceType === EServiceType.paid ? 'Объявления' : 'Баллы',
    serviceTypes: [mapServiceType(service.serviceType)],
    count: service.count,
    durationInDays: service.durationInDays,
    auctionPoints: service.auctionPoints,
    price: service.price,
    marketingPrice: data.announcementPrice,
  })),
  confirmationPopupTitle: `Купить пакет из ${data.totalAnnouncementsCount} ${pluralizeOfferLabel(
    data.totalAnnouncementsCount,
  )}`,
  widgetSource: mapWidgetSource(data.type),
  polygonIds: data.polygonIds,
});
